import SpriteSymbol from "../../../../../../../node_modules/normacs_web/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/normacs_web/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-sides",
  "use": "arrow-sides-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"arrow-sides\">\n  <path fill=\"currentColor\" fill-rule=\"nonzero\" d=\"M54.125 29L38 15.62c-.915-.759-1.617-1.62-3-1.62-1.875 0-3 1.548-3 3v9H11c-1.65 0-3 1.35-3 3v6c0 1.65 1.35 3 3 3h21v9c0 1.452 1.125 3 3 3 1.383 0 2.085-.861 3-1.62L54.125 35C55.274 34.064 56 33.335 56 32s-.726-2.061-1.875-3z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol